// extracted by mini-css-extract-plugin
export default {"text":"SupportModal_text__cXeJo"};